export enum AccountType {
  Personal = 'Personal',
  Corporate = 'Corporate',
  Academic = 'Academic',
}

// for the record this is a horrible name
export enum AccountPlanType {
  Personal = 'Personal',
  Enterprise = 'Enterprise',
  Academic = 'Academic',
  Pro = 'Pro',
  Teams = 'Teams',
  Free = 'Free',
  ThirtyDayTrial = '30 Day Trial',
  Legacy = 'Legacy',
}

export type Account = {
  name: string;
  accountType: AccountType; // rename this to orgtype
  accountPlanType: AccountPlanType; // rename this to accountType
  id?: string;
  memberCount?: number;
  isEnterprise?: boolean;
  username: string;
  personalOrgId?: string;
  isDummyAccount?: boolean;
};
